import TwtPhotosNeighborhood from '~/tenants/twt/performable/photo/TwtPhotosNeighborhood';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TwtPhotoType } from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import TwtPhotosHighlights from '~/tenants/twt/performable/photo/TwtPhotosHighlights';
import { TWT_PHOTO_EXTRA } from '~/tenants/twt/performable/photo/TwtPhotoJob';
import { TenantPackageAddOnGeneric } from '~/tenants/common/package';
import { format_money } from '~/components/Money';
import React from 'react';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import Big from 'big.js';
import { TwtOrderType } from '~/tenants/twt/model/enums';
import TwtPhotoDomain from '~/tenants/twt/performable/photo/TwtPhotoDomain';
import TwtPhotosExtra from '~/tenants/twt/performable/photo/TwtPhotosExtra';

export default function TwtPhotosAddOns({
  persona,
  type,
  order,
}: {
  order: TwtOrderType;
  persona: PersonaType;
  type: TwtPhotoType;
}) {
  return (
    <>
      {order === TwtOrderType.COMMERCIAL && <TwtPhotosHighlights persona={persona} order={order} />}
      {[TwtOrderType.FOR_SALE_LISTING, TwtOrderType.LONG_TERM_RENTAL, TwtOrderType.SHORT_TERM_RENTAL].includes(
        order,
      ) && (
        <>
          {type === TwtPhotoType.INTERIOR_EXTERIOR && (
            <>
              <TwtPhotosExtra persona={persona} />
              <TwtPhotosHighlights persona={persona} order={order} />
            </>
          )}
        </>
      )}
      <TwtPhotoDomain persona={persona} />
      {order !== TwtOrderType.COMMERCIAL && <TwtPhotosNeighborhood persona={persona} />}
    </>
  );
}
